module.exports = __webpack_public_path__ + "assets/99ef22f93071bdd36ebda714594ccd01.mp3";